module.exports = __webpack_public_path__ + "static/media/zhong@2x.2cc43ce3.png";